<template>
  <div v-if="isInitial">
    <Loading :loading="this.loading"></Loading>
    <div v-show="!loading" class="content-wrapper" v-bind:class="{ modal_open: modalActive }">
      <div class="container">
        <article>
          <div class="step-bar-container">
            <ul>
              <li class="li-step">
                <span class="stepnum num01"></span>
                <span class="steptext">条件入力</span>
              </li>
              <li class="li-step active">
                <span class="stepnum num02"></span>
                <span class="steptext">見積り確認</span>
              </li>
              <li class="li-step">
                <span class="stepnum num03"></span>
                <span class="steptext">連絡先入力</span>
              </li>
              <li class="li-step">
                <span class="stepnum num04"></span>
                <span class="steptext">最終確認</span>
              </li>
            </ul>
          </div>
        <section class="section half-circle mb24">
          <div class="half-circle-top">
            <img src="/lib/images/ic_car.svg" alt="" class="half-circle-top-icon">
          </div>
          <h2 class="text-center mt20 mb4 fs16 font-weight-bold">コミっと車検お見積り</h2>
          <p class="text-center fs13 mb20 car-type-text">{{ Manufacturer.manufacturer_name }} {{firstRegistrationOnWareki.gengo}}{{firstRegistrationOnWareki.year}}年{{firstRegistrationOnWareki.month}}月登録</p>
          <p class="mb0 text-center"><img class="w90p " src="/lib/images/text_01.png" alt=""></p>

          <p class="text-center fs50 font-weight-bold line-height1_1">{{ $filters.addComma(price.total) }}<span class="ml4 fs20 va-middle">円(税込)</span></p>

          <p class="text-right"><span>※価格は{{ currentDate }}時点</span></p>

          <div class="bg-gray1 pd12 mb12">
            <dl class="dl estimate-result-list mb12">
              <dt class="fs16">法定費用</dt>
              <dd class="mb4 fs16">{{ $filters.addComma(price.legal_fee.subtotal) }}円</dd>
              <dt class="list">重量税</dt>
              <dd>{{ $filters.addComma(price.legal_fee.weight_tax) }}円</dd>
              <dt class="list">自賠責保険24ヶ月</dt>
              <dd>{{ $filters.addComma(price.legal_fee.cali_fee) }}円</dd>
              <dt class="list">印紙代</dt>
              <dd class="mb12">{{ $filters.addComma(price.legal_fee.revenue_stamp_fee) }}円</dd>

              <dt class="fs16">車検＋整備費用</dt>
              <dd class="mb4 fs16">{{ $filters.addComma(price.price.subtotal) }}円</dd>
              <dt class="list">定額整備部品の交換</dt>
              <dd class="color-green2 font-weight-bold">コミコミ！</dd>
              <dt class="list">整備保証・法定12ヶ月点検*</dt>
              <dd class="color-green2 font-weight-bold">コミコミ！</dd>
            </dl>

              <p class="fs11 pl5p pr5p">対象部品に異常がある場合は無償で交換・整備します
（半年間または走行距離1万kmに達した時点のいずれか短い期間が保証対象）
また、車検後の法定12ヶ月点検を無料で実施します</p>

            <dl class="dl estimate-result-list mb4" v-if="price.price.oil_exchanged_fee !== 0">
              <dt class="list">エンジンオイル交換不要</dt>
              <dd class="color-green2 font-weight-bold">{{ $filters.addComma(price.price.oil_exchanged_fee) }}円</dd>
            </dl>

            <dl class="dl estimate-result-list mb4" v-if="price.coupon_fee !== null">
                <dt class="fs16">クーポン</dt>
                <dd class="mb12 fs16">{{ $filters.addComma(price.coupon_fee) }}円</dd>
            </dl>
          </div>
          <p class="fs11 color-font2 mb0">※エコカーのお客様の場合、エコカー減税の適用により車検費用が変わる可能性があります。</p>

          <p class="fs11 color-font2">※バンパー、ドアミラー、フロントガラスなど定額対象外の整備が発生し追加の整備費用がかかることがあります。定額整備部品の一覧や交換基準は<a href="#" v-on:click="toAgreement()">こちら</a>をご覧ください。</p>

          <button class="button button-gray-o fs13 mt20 mb12 w50p" v-on:click="sendMail()"><img class="mr4 va-baseline" src="/lib/images/ic_mail.svg" alt="">メールで共有</button>
          <button class="button button-gray fs16 mt20 mb12 w85p" v-on:click="toEstimateDetail()">見積り詳細</button>
          <div class="text-center">

            <div v-if="pitlockIsMaintenance">
              <button class="button fs14 mb12 w85p" disabled>次へ</button>
              <p class="fs13 font-weight-bold color-red2 text-center mb4">現在メンテナンス中のためご利用いただけません。ご不便をお掛けいたしますが、後ほどご利用下さい。</p>
            </div>
            <div v-else-if="expiryOnDate < sixMonthLater">
              <button v-on:click='nextPage()' class="button fs14 mb12 w85p">次へ</button>
            </div>
            <div v-else>
              <p class="fs13 font-weight-bold color-font2 text-center mb4">車検まで半年を切るとSSに予約できます</p>
              <button class="button fs14 mb12 w85p" disabled>次へ</button>
            </div>
          </div>
        </section>

        <div class="content-box-txt mr16 ml16 fs11 color-font2">
          ※車検日までに走行距離が大きく増えた場合や、車両重量が実測と異なる場合、見積り金額が変動する場合があります
        </div>
        <div class="content-box-txt mr16 ml16 fs11 color-font2">
          ※半年間または走行距離10,000kmに達した時点のいずれか短い期間の保証となります。
        </div>

        <div v-if="estimateBannerUrl === '' || estimateBannerUrl === undefined">
        </div>
        <div v-else style="text-align:center">
          <section class="section white-panel mb12">
            <a href="#" v-on:click="jsOpenBrowser()">
              <img src="/lib/images/estimate_campaign_banner.png">
            </a>
          </section>
        </div>

        <section class="section3 half-circle mb24">
          <div class="box mt24 ml16 mr16 mb16">
            <h3 class="content-box__ttl mb5">
              <img class="mb20" src="/lib/images/ic_car_character_1.svg" alt="" style="width: 16px; height: 18px;" >【お読みください】<br>
              コミっと車検でも追加整備をお勧めすることがあります
            </h3>
            <div class="info-box-txt1 fs12.46 mb12">
              コミっと車検では、お得な価格を実現しながらも安全性を犠牲にすることはありません。
              そのため、コミコミ価格（規定の部品）に含まれない大事な部品交換や修理をお勧めする場合があります。
              詳しくは以下をご確認ください
            </div>
            <div class="info-box pb16">
              <h3 class="content-box__ttl mb16 ml12 mr16 pt16">
                コミコミ価格に含まれないが重要な整備箇所の例
              </h3>
              <ul class="content-box-list mb16">
                <li class="content-box-item"><img src="/lib/images/icon09.svg" alt=""></li>
                <li class="content-box-item"><img src="/lib/images/icon10.svg" alt=""></li>
                <li class="content-box-item"><img src="/lib/images/icon11.svg" alt=""></li>
              </ul>
              <button class="button fs16 w85p" id="reasonMaint" v-on:click='modalOpen($event)'>これらの整備が必要な理由</button>
            </div>
          </div>
        </section>
        <div class="section1">
          <img src="/lib/images/img_26.png" alt="">
        </div>
        <div class="section3 pb40 mb8" style="border: 0;">
          <div class="list-box">
            <h3 class="ttl pt40 mb24">
              <img src="/lib/images/ttl_07.svg" alt="">
            </h3>
            <ul class="list pl16 pr16">
              <li class="list-item">
                <div class="list-icon">
                  <img src="/lib/images/icon01.png" alt="">
                </div>
                <h3 class="list-ttl">充実</h3>
                <p class="list-txt1">車検でよく交換される<span>30項目以上の部品</span>を対象に、点検整備を実施</p>
              </li>
              <li class="list-item">
                <div class="list-icon">
                  <img src="/lib/images/icon02.png" alt="">
                </div>
                <h3 class="list-ttl">安心</h3>
                <p class="list-txt1">車検に必要な部品は異常箇所を全て交換。<span>エンジン・ブレーキまわりの部品は予防交換</span>を実施</p>
              </li>
              <li class="list-item">
                <div class="list-icon">
                  <img src="/lib/images/icon03.png" alt="">
                </div>
                <h3 class="list-ttl">お得</h3>
                <p class="list-txt1">見積りをアプリで行い、店頭点検の工程を効率化することで<span>お得な価格を実現</span></p>
              </li>
              <li class="list-item">
                <div class="list-icon">
                  <img src="/lib/images/icon04.png" alt="">
                </div>
                <h3 class="list-ttl">アフターサービス</h3>
                <p class="list-txt1">車検後の<span>法定12ヶ月点検を無料</span>で実施</p>
              </li>
              <li class="list-item">
                <div class="list-icon">
                  <img src="/lib/images/icon05.png" alt="">
                </div>
                <h3 class="list-ttl">保証</h3>
                <p class="list-txt1">対象部品に異常がある場合は<span>無償で交換・整備</span></p>
                <p class="list-txt2">※半年間または走行距離1万kmに達した時点のいずれか短い期間が保証対象です</p>
              </li>
            </ul>
          </div>
          <div class="content-box mt24 ml16 mr16 mb16">
            <div class="content-box__1 mr24 ml24">
              <h3 class="content-box__ttl mb16">
                <img src="/lib/images/icon12.svg" alt="">価格に含まれる部品・整備の例
              </h3>
              <ul class="content-box-list mb16">
                <li class="content-box-item"><img src="/lib/images/icon06.svg" alt=""></li>
                <li class="content-box-item"><img src="/lib/images/icon07.svg" alt=""></li>
                <li class="content-box-item"><img src="/lib/images/icon08.svg" alt=""></li>
              </ul>
              <div class="content-box-btn">
                <a class="pd12 modal-syncer" id="targetParts" v-on:click='modalOpen($event)'>価格に含まれる対象部品すべてを見る</a>
              </div>
            </div>
            <div class="content-box__2 mr24 ml24 mt16">
              <h3 class="content-box__ttl mb16 pt16">
                <img src="/lib/images/icon13.svg" alt="">価格に含まれない部品・整備の例
              </h3>
              <ul class="content-box-list mb16">
                <li class="content-box-item"><img src="/lib/images/icon09.svg" alt=""></li>
                <li class="content-box-item"><img src="/lib/images/icon10.svg" alt=""></li>
                <li class="content-box-item"><img src="/lib/images/icon11.svg" alt=""></li>
              </ul>
            </div>
            <p class="content-box-txt mr16 ml16 mb16">
              ※バンパー、フロントガラス、サイドミラーなど車体の破損に関わる修理費用は含まれません。
            </p>
          </div>
          <div class="info-box ml16 mr16 pt20 pr16 pl16 pb16">
            <h3 class="info-box-ttl1">
              <img src="/lib/images/icon14.svg" alt="">通常の車検との違い
            </h3>
            <h3 class="info-box-ttl2 mt8">
              来店せずに見積りできて、追加整備費用がかかりません
            </h3>
            <p class="info-box-txt1 mt8">
              通常の車検は、来店し30〜60分間点検を行った上で見積りを出しますが、実際には車検時に異常が見つかったり、部品交換を勧められたり<span>最終的に当初の見積り金額をオーバーする</span>ことがあります。
              一方でコミっと車検は、車種や年数、走行距離などから見積りを作成。車検時には規定の基準に従って部品交換・整備を行い、<sup>※</sup><span>追加費用は発生しません</span>。
            </p>
            <div class="info-box-img mb8">
                <img src="/lib/images/img_107.svg" alt="">
            </div>
            <p class="info-box-txt2 ">
              ※規定の整備対象部品において追加の費用は発生しません。それ以外の整備、部品交換はお客様の同意の上で実施し、追加作業の扱いとして追加費用を頂く可能性がございます。（例：タイヤ交換等）
            </p>
          </div>
        </div>

        <div class="section8" style="border: 0;">
          <div class="ttl-01 mb24 pt40">
            <img src="/lib/images/ttl_12.svg" alt="">
          </div>
          <ul class="faq pb44">
            <li class="faq-item">
              <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                <div class="faq-q__left">
                  <img src="/lib/images/txt_11.svg" alt="">
                </div>
                <p class="faq-q__right ml8">
                  コミっと車検は、普通の車検とどこが違うのですか？
                </p>
              </div>
              <div class="faq-a mr16 ml16">
                <div class="faq-a__box pt8 pb24">
                  <div class="faq-a__left">
                    <img src="/lib/images/txt_12.svg" alt="">
                  </div>
                  <p class="faq-a__right ml8">
                    コミっと車検は、お見積から決済までをアプリで完了でき、オイルやバッテリーなど定額整備対象部品に異常があれば、追加整備費用なしのコミコミ価格で整備・交換する車検です。(タイヤ、タイミングベルトやバンパー、フロントガラスなど一部の部品は定額整備の対象外となります。詳しくは、アプリ上の詳細説明をご参照ください)
                  </p>
                </div>
              </div>
            </li>
            <li class="faq-item">
              <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                <div class="faq-q__left">
                  <img src="/lib/images/txt_11.svg" alt="">
                </div>
                <p class="faq-q__right ml8">
                  車を見ないで定めた整備項目で、安全性に問題はないのですか？
                </p>
              </div>
              <div class="faq-a mr16 ml16">
                <div class="faq-a__box pt8 pb24">
                  <div class="faq-a__left">
                    <img src="/lib/images/txt_12.svg" alt="">
                  </div>
                  <p class="faq-a__right ml8">
                    車両引受の際に整備員が点検・確認を行い、定額整備対象部品に異常があった場合は、当初ご案内していたお見積り金額に追加費用なしで全て整備・部品交換をします。また、きちんとした整備・交換基準に即して車検を実施することを徹底しています。(整備・交換基準についてはアプリ上の詳細説明をご参照ください)
                  </p>
                </div>
              </div>
            </li>
            <li class="faq-item">
              <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                <div class="faq-q__left">
                  <img src="/lib/images/txt_11.svg" alt="">
                </div>
                <p class="faq-q__right ml8">
                  どんな車でも車検を受けられますか？
                </p>
              </div>
              <div class="faq-a mr16 ml16">
                <div class="faq-a__box pt8 pb24">
                  <div class="faq-a__left">
                    <img src="/lib/images/txt_12.svg" alt="">
                  </div>
                  <p class="faq-a__right ml8">
                    外国車、レクサス等の一部車種はお取り扱いしておりません。その他、「コミっと車検の対象となる自動車」については、アプリ上の詳細説明、もしくは「コミっと車検利用規約」をご参照ください。
                  </p>
                </div>
              </div>
            </li>
            <li class="faq-item">
              <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                <div class="faq-q__left">
                  <img src="/lib/images/txt_11.svg" alt="">
                </div>
                <p class="faq-q__right ml8">
                  車検証が無くても見積りはできますか？
                </p>
              </div>
              <div class="faq-a mr16 ml16">
                <div class="faq-a__box pt8 pb24">
                  <div class="faq-a__left">
                    <img src="/lib/images/txt_12.svg" alt="">
                  </div>
                  <p class="faq-a__right ml8">
                    車検証情報を手入力していただければ可能です。但し、車検証情報と走行距離情報等の必要情報を全て入力して頂かないとお見積り金額はご提示できません。また、お車をお持ち込み頂いた際に、お見積り時にご入力頂いたお車の情報と大幅に乖離がある場合は、再度、お見積りを取り直して頂くことがあります。ただし、車検実施時には車検証が必要です。
                  </p>
                </div>
              </div>
            </li>
            <li class="faq-item">
              <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                <div class="faq-q__left ">
                  <img src="/lib/images/txt_11.svg" alt="">
                </div>
                <p class="faq-q__right ml8">
                  車検証のどのQRを読み込めばいいですか？
                </p>
              </div>
              <div class="faq-a mr16 ml16">
                <div class="faq-a__box pt8 pb24">
                  <div class="faq-a__left">
                    <img src="/lib/images/txt_12.svg" alt="">
                  </div>
                  <p class="faq-a__right ml8">
                    お手元の車検証に印刷されたＱＲコードの数をご覧いただき、画面の指示に従って該当する選択肢を押下してください。<br/>
                    読取画面が起動すると読取枠の上部にガイドが表示されますので、表示されている位置のＱＲコードを読み取ってください。<br/>
                    <br/>
                    ・普通自動車で車検証がA4サイズ(210㎜×297㎜)の場合<br/>
                    「８個」を選んでください。ＱＲコード８個のうち、左から数えて２～６個目の合計５つを読み込んでください。<br/>
                    <br/>
                    ・普通自動車で車検証がA6(105㎜×177.8㎜)サイズの場合※2023年1月より交付の電子車検証<br/>
                    「５個」を選んでください。すべてのＱＲコードを読み込み、次の画面で車検満了日を入力してください。<br/>
                    <br/>
                    ・軽自動車の場合<br/>
                    「６個以下」を選んでください。すべてのＱＲコードを読み込んでください。
                  </p>
                </div>
              </div>
            </li>
            <li class="faq-item">
              <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                <div class="faq-q__left">
                  <img src="/lib/images/txt_11.svg" alt="">
                </div>
                <p class="faq-q__right ml8">
                  追加費用が発生することはないですか？
                </p>
              </div>
              <div class="faq-a mr16 ml16">
                <div class="faq-a__box pt8 pb24">
                  <div class="faq-a__left">
                    <img src="/lib/images/txt_12.svg" alt="">
                  </div>
                  <p class="faq-a__right ml8">
                    定額整備対象部品については、アプリ上の事前見積り金額から追加費用はかかりません。定額整備対象部品外で、車検を通すための部品および、お客様のご希望によって整備・交換する部品については、追加整備として追加費用を頂きます。(定額整備対象部品についてはアプリ上の詳細説明をご参照ください)
                  </p>
                </div>
              </div>
            </li>
            <li class="faq-item">
              <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                <div class="faq-q__left">
                  <img src="/lib/images/txt_11.svg" alt="">
                </div>
                <p class="faq-q__right ml8">
                  代車費用は含まれていますか？
                </p>
              </div>
              <div class="faq-a mr16 ml16">
                <div class="faq-a__box pt8 pb24">
                  <div class="faq-a__left">
                    <img src="/lib/images/txt_12.svg" alt="">
                  </div>
                  <p class="faq-a__right ml8">
                    アプリ上の事前見積りには含まれておりません。代車については車検を実施する店舗にお問い合わせください。
                  </p>
                </div>
              </div>
            </li>
            <li class="faq-item">
              <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                <div class="faq-q__left">
                  <img src="/lib/images/txt_11.svg" alt="">
                </div>
                <p class="faq-q__right ml8">
                  車検に何日間かかりますか？
                </p>
              </div>
              <div class="faq-a mr16 ml16">
                <div class="faq-a__box pt8 pb24">
                  <div class="faq-a__left ">
                    <img src="/lib/images/txt_12.svg" alt="">
                  </div>
                  <p class="faq-a__right ml8">
                    車検実施に必要な日数については、車検を実施する店舗にお問い合わせください。
                  </p>
                </div>
              </div>
            </li>
            <li class="faq-item">
              <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                <div class="faq-q__left">
                  <img src="/lib/images/txt_11.svg" alt="">
                </div>
                <p class="faq-q__right ml8">
                  どんな整備工場で整備されるのですか？
                </p>
              </div>
              <div class="faq-a mr16 ml16">
                <div class="faq-a__box pt8 pb24">
                  <div class="faq-a__left">
                    <img src="/lib/images/txt_12.svg" alt="">
                  </div>
                  <p class="faq-a__right ml8">
                    コミっと車検に加盟している指定・認証工場、もしくは提携整備工場で整備しています。
                  </p>
                </div>
              </div>
            </li>
            <li class="faq-item">
              <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                <div class="faq-q__left">
                  <img src="/lib/images/txt_11.svg" alt="">
                </div>
                <p class="faq-q__right ml8">
                  車検を受ける店舗は自由に選べますか？
                </p>
              </div>
              <div class="faq-a mr16 ml16">
                <div class="faq-a__box pt8 pb24">
                  <div class="faq-a__left">
                    <img src="/lib/images/txt_12.svg" alt="">
                  </div>
                  <p class="faq-a__right ml8">
                    マイSSにご登録いただいた店舗が選択されます。他の店舗での車検実施をご希望の場合は、アプリのトップ画面からマイSSの登録をご変更ください。
                  </p>
                </div>
              </div>
            </li>
            <li class="faq-item">
              <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                <div class="faq-q__left">
                    <img src="/lib/images/txt_11.svg" alt="">
                </div>
                <p class="faq-q__right ml8">
                  担当整備士の実績は？
                </p>
              </div>
              <div class="faq-a mr16 ml16">
                <div class="faq-a__box pt8 pb24">
                  <div class="faq-a__left">
                    <img src="/lib/images/txt_12.svg" alt="">
                  </div>
                  <p class="faq-a__right ml8">
                    200時間以上の研修を受け、国家資格を取得した信頼できる整備士がしっかりと作業します。
                  </p>
                </div>
              </div>
            </li>
            <li class="faq-item">
              <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                <div class="faq-q__left">
                  <img src="/lib/images/txt_11.svg" alt="">
                </div>
                <p class="faq-q__right ml8">
                  整備内容を説明してもらえますか？
                </p>
              </div>
              <div class="faq-a mr16 ml16">
                <div class="faq-a__box pt8 pb24">
                  <div class="faq-a__left ">
                    <img src="/lib/images/txt_12.svg" alt="">
                  </div>
                  <p class="faq-a__right ml8">
                    車検前のお車の引受時、整備対象部品・箇所の状態と、必要な整備作業についてご説明させて頂きます。
                  </p>
                </div>
              </div>
            </li>
            <li class="faq-item">
              <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                <div class="faq-q__left">
                  <img src="/lib/images/txt_11.svg" alt="">
                </div>
                <p class="faq-q__right ml8">
                  予約内容の変更/キャンセルはできますか？
                </p>
              </div>
              <div class="faq-a mr16 ml16">
                <div class="faq-a__box pt8 pb24">
                  <div class="faq-a__left">
                    <img src="/lib/images/txt_12.svg" alt="">
                  </div>
                  <p class="faq-a__right ml8">
                    予約内容、車検スケジュールの変更は、車検を実施する店舗にお問い合わせください。整備内容確定後のキャンセルは、原則お断りさせて頂いています。
                  </p>
                </div>
              </div>
            </li>
            <li class="faq-item">
              <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                <div class="faq-q__left">
                  <img src="/lib/images/txt_11.svg" alt="">
                </div>
                <p class="faq-q__right ml8">
                  法定費用は車検当日に現金で支払うのですか？
                </p>
              </div>
              <div class="faq-a mr16 ml16">
                <div class="faq-a__box pt8 pb24">
                  <div class="faq-a__left">
                    <img src="/lib/images/txt_12.svg" alt="">
                  </div>
                  <p class="faq-a__right ml8">
                    法定費用を含む車検費用の全額が、車検終了後にアプリ経由でお支払い頂けます。店頭にて現金でも全額支払いが可能です。
                  </p>
                </div>
              </div>
            </li>
            <li class="faq-item">
              <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                <div class="faq-q__left">
                  <img src="/lib/images/txt_11.svg" alt="">
                </div>
                <p class="faq-q__right ml8">
                  支払のタイミングはいつですか？
                </p>
              </div>
              <div class="faq-a mr16 ml16">
                <div class="faq-a__box pt8 pb24">
                  <div class="faq-a__left">
                    <img src="/lib/images/txt_12.svg" alt="">
                  </div>
                  <p class="faq-a__right ml8">
                    車検完了後、お引渡し時までにアプリからいつでもお支払い頂けます。現金でのお支払いをご希望の場合は、お引渡し時に店頭でお支払い頂けます。
                  </p>
                </div>
              </div>
            </li>
            <li class="faq-item">
              <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                <div class="faq-q__left">
                  <img src="/lib/images/txt_11.svg" alt="">
                </div>
                <p class="faq-q__right ml8">
                  どのような支払方法がありますか？
                </p>
              </div>
              <div class="faq-a mr16 ml16">
                <div class="faq-a__box pt8 pb24">
                  <div class="faq-a__left">
                    <img src="/lib/images/txt_12.svg" alt="">
                  </div>
                  <p class="faq-a__right ml8">
                    アプリ上でのクレジットカード支払い、もしくは店頭での現金支払いのいずれかを選択して頂けます。<br/>
                    (店頭でのクレジットカードでのお支払いは、原則お断りさせて頂いています。)
                  </p>
                </div>
              </div>
            </li>
            <li class="faq-item">
              <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                <div class="faq-q__left">
                  <img src="/lib/images/txt_11.svg" alt="">
                </div>
                <p class="faq-q__right ml8">
                  保証期間はありますか？
                </p>
              </div>
              <div class="faq-a mr16 ml16">
                <div class="faq-a__box pt8 pb24">
                <div class="faq-a__left">
                  <img src="/lib/images/txt_12.svg" alt="">
                </div>
                <p class="faq-a__right ml8">
                  車検後半年または走行距離1万km以内に整備対象品目の部品で異常が発生した場合は、無料で交換整備を実施します。また、車検実施から1年後の法定12ヶ月点検を無料で実施します。
                </p>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div class="section2">
          <div class="info pb20 pt28">
            <div class="info_btn ml28 mr32">
              <div v-if="pitlockIsMaintenance">
                <button class="button fs14 mb12 w85p" disabled>次へ</button>
                <p class="fs13 font-weight-bold color-red2 text-center mb4">現在メンテナンス中のためご利用いただけません。ご不便をお掛けいたしますが、後ほどご利用下さい。</p>
              </div>
              <div v-else-if="expiryOnDate < sixMonthLater">
                <button v-on:click='nextPage()' class="button fs14 mb12 w85p">次へ</button>
              </div>
              <div v-else>
                <p class="fs13 font-weight-bold color-font1 text-center mb4">車検まで半年を切るとSSに予約できます</p>
                <button class="button fs14 mb12 w85p" disabled>次へ</button>
            </div>
            </div>
          </div>
        </div>

          <Lease
            v-bind:car="this.carStore.car"
            v-bind:popInfoNo="this.nativeDataStore.nativeData.popinfoid"
            v-bind:transitionFrom="'fromEstimate'"
            v-bind:tsid="this.nativeDataStore.nativeData.tsid"
            v-bind:otoken="this.nativeDataStore.nativeData.otoken"
            @toLeaseTop="toLeaseTop"></Lease>
        </article>
      </div>

      <div class="modal_overlay"  style="background-color: rgba(0, 0, 0, 0.75);">
        <div class="modal_container">
          <div v-if="modalTagetParts">
            <div class="modal-content pt20 pr20 pl20" style="top: 16px; left: 16px;">
              <h3 class="ttl-01 mb20">
                規定の整備対象部品と整備基準
              </h3>
              <div class="modal-content__1">
                <h3 class="ttl-02 pl16 mb20">予防交換する部品</h3>
                <div class="modal-content__list">
                  <dl class="pb4">
                  <dt>対象部品</dt>
                  <dd>整備基準</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        1
                      </div>
                      <div class="txt ml8">
                        ブレーキフルード
                      </div>
                    </dt>
                    <dd>2年以上経過</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        2
                      </div>
                      <div class="txt ml8">
                        ブレーキライニング<br/>・シュー
                      </div>
                    </dt>
                    <dd>摩擦材2mm以下</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        3
                      </div>
                      <div class="txt ml8">
                        ブレーキパッド
                      </div>
                    </dt>
                    <dd>摩擦材3mm以下</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        4
                      </div>
                      <div class="txt ml8">
                        エンジンオイル
                      </div>
                    </dt>
                    <dd>半年以上経過</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        5
                      </div>
                      <div class="txt ml8">
                        オイルエレメント
                      </div>
                    </dt>
                    <dd>オイル交換2回に1回</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        6
                      </div>
                      <div class="txt ml8">
                        バッテリー
                      </div>
                    </dt>
                    <dd>３年以上経過（ハイブリッド車の補機バッテリーは5年。保証期間が3年以上の場合は保証期間に準拠）</dd>
                  </dl>
                </div>
              </div>
              <div class="modal-content__1 mt24 pb12">
                <h3 class="ttl-02 pl16 mb20">異常があれば交換する部品</h3>
                <div class="modal-content__list">
                  <dl class="pb4">
                  <dt>対象部品</dt>
                  <dd>整備基準</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        1
                      </div>
                      <div class="txt ml8">
                        電球
                      </div>
                    </dt>
                    <dd>切れたら</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        2
                      </div>
                      <div class="txt ml8">
                        ヘッドライトコート
                      </div>
                    </dt>
                    <dd>ロービーム1灯あたり6400cd未満</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        3
                      </div>
                      <div class="txt ml8">
                        発煙筒
                      </div>
                    </dt>
                    <dd>使用期限超過時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        4
                      </div>
                      <div class="txt ml8">
                        ワイパーブレード
                      </div>
                    </dt>
                    <dd>ふき残し・ひび割れ発生時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        5
                      </div>
                      <div class="txt ml8">
                        ミッションオイル<br/>（ATF/CVTF）
                      </div>
                    </dt>
                    <dd>油色変化・劣化時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        6
                      </div>
                      <div class="txt ml8">
                        デフオイル
                      </div>
                    </dt>
                    <dd>油色変化・劣化時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        7
                      </div>
                      <div class="txt ml8">
                        クラッチオイル
                      </div>
                    </dt>
                    <dd>油色変化・劣化時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        8
                      </div>
                      <div class="txt ml8">
                        パワステフルード
                      </div>
                    </dt>
                    <dd>油色変化・劣化時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        9
                      </div>
                      <div class="txt ml8">
                        LLC
                      </div>
                    </dt>
                    <dd>液量低下、液色変化時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        10
                      </div>
                      <div class="txt ml8">
                        ラジエターバルブ
                      </div>
                    </dt>
                    <dd>異音、緩み、亀裂発生時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        11
                      </div>
                      <div class="txt ml8">
                        ラジエーター本体
                      </div>
                    </dt>
                    <dd>液漏れあり</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        12
                      </div>
                      <div class="txt ml8">
                        エアーエレメント
                      </div>
                    </dt>
                    <dd>異音、目詰まり</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        13
                      </div>
                      <div class="txt ml8">
                        スパークプラグ
                      </div>
                    </dt>
                    <dd>異常発生時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        14
                      </div>
                      <div class="txt ml8">
                        Vベルト
                      </div>
                    </dt>
                    <dd>異音、緩み、亀裂発生時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        15
                      </div>
                      <div class="txt ml8">
                        ハブベアリング
                      </div>
                    </dt>
                    <dd>異音、ガタつき発生時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        16
                      </div>
                      <div class="txt ml8">
                        ステアリングギアボックス
                      </div>
                    </dt>
                    <dd>液漏れあり</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        17
                      </div>
                      <div class="txt ml8">
                        ステアリングブーツ
                      </div>
                    </dt>
                    <dd>亀裂・グリス漏れ発生時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        18
                      </div>
                      <div class="txt ml8">
                        ドライブシャフトブーツ
                      </div>
                    </dt>
                    <dd>亀裂・グリス漏れ発生時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        19
                      </div>
                      <div class="txt ml8">
                        タイロットエンドブーツ
                      </div>
                    </dt>
                    <dd>亀裂・グリス漏れ発生時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        20
                      </div>
                      <div class="txt ml8">
                        スタビライザーリンク
                      </div>
                    </dt>
                    <dd>油滴・液漏れ発生時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        21
                      </div>
                      <div class="txt ml8">
                        ロアアームブーツ
                      </div>
                    </dt>
                    <dd>亀裂・グリス漏れ発生時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        22
                      </div>
                      <div class="txt ml8">
                        プロペラシャフト
                      </div>
                    </dt>
                    <dd>亀裂・損傷発生時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        23
                      </div>
                      <div class="txt ml8">
                        ショックアブソーバー
                      </div>
                    </dt>
                    <dd>油滴・液漏れあり</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        24
                      </div>
                      <div class="txt ml8">
                        ブレーキドラム
                      </div>
                    </dt>
                    <dd>亀裂・損傷発生時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        25
                      </div>
                      <div class="txt ml8">
                        ホイールシリンダー
                      </div>
                    </dt>
                    <dd>亀裂・損傷発生時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        26
                      </div>
                      <div class="txt ml8">
                        ディスクローター
                      </div>
                    </dt>
                    <dd>亀裂・損傷発生時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        27
                      </div>
                      <div class="txt ml8">
                        ディスクキャリパー
                      </div>
                    </dt>
                    <dd>亀裂・損傷発生時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        28
                      </div>
                      <div class="txt ml8">
                        ブレーキホース
                      </div>
                    </dt>
                    <dd>亀裂・損傷発生時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        29
                      </div>
                      <div class="txt ml8">
                        マフラーコート
                      </div>
                    </dt>
                    <dd>錆による腐食の発生時</dd>
                  </dl>
                  <dl class="pt12 pb12">
                    <dt class="pr12">
                      <div class="numer">
                        30
                      </div>
                      <div class="txt ml8">
                        下回り塗装
                      </div>
                    </dt>
                    <dd>錆による腐食の発生時</dd>
                  </dl>
                </div>
              </div>
              <div class="info pd12">
                <h3 class="ttl mb4">※一部のエリアにおいては、下記パーツは対象外となります</h3>
                <p class="txt">
                  （22）プロペラシャフト、（23）ショックアブソーバー、（26）ディスクローター、（27）ディスクキャリパー、（29）マフラーコート、（30）下回り塗装
                </p>
              </div>
              <p><a class="btn-close" v-on:click="modalClose()"><img src="/lib/images/icon15.svg" alt=""></a></p>
            </div>
          </div>
          <div v-if="modalReasonMaintActive">
            <div class="modal_body radius8 pt24 pd16 mt8p mb8p">
              <div class="modal-content__1">
                <h3 class="ttl-01 fs16">
                  コミコミ価格に含まれない追加整備が必要な理由
                </h3>
                <img class="w100p pt16 pb16" src="/lib/images/line-blue.svg" alt="">
                <div class="modal-content__list">
                  <p class="info-box-txt1 fs14">
                    特に目立つのは乗っていると必ず磨耗する部品や、車体の破損による修理です。これらは適切なタイミングで整備をお勧めさせていただきます
                  </p>
                  <dl class="pb4"></dl>
                  <h3 class="content-box__ttl pt12">
                    タイヤ交換
                  </h3>
                  <p class="info-box-txt1 fs14">
                    車検を通すにはタイヤの溝が1.6mm（タイヤ側面の△印の位置）以下にならないようにする必要がありますが、コミっと車検では安全のため2mmを基準として交換を推奨しています。交換する場合には別途実費にてタイヤのご購入が必要です。<br>
                    参考通常価格：１〜３万円/本
                  </p>
                  <dl class="pb4"></dl>
                  <h3 class="content-box__ttl pt12">
                    タイミングベルト交換
                  </h3>
                  <p class="info-box-txt1 fs14">
                    10万kmまたは10年を目安に交換する部品です。 エンジンの動力を伝える重要な部品なので、劣化の兆候が見られたら切れてしまう前に交換する必要があります。<br>
                    参考価格：5〜8万円
                  </p>
                  <dl class="pb4"></dl>
                  <h3 class="content-box__ttl pt12">
                    その他、規定外の部品交換や車体の破損
                  </h3>
                  <p class="info-box-txt1 fs14">
                    そのほか規定の部品以外の交換が必要な場合や、車体の破損に関わる部品（パンパー、フロントガラス、ミラーなど）の交換や修理が必要な場合は別途費用がかかります。
                  </p>
                  <dl class="pb4"></dl>
                  <p class="info-box-txt1 pt12 fs13 color-font2">
                    ※追加の整備は、お客様に内容と価格をご合意いただいた上での交換・修理になります。無断で交換修理を行うことはございませんのでご安心ください
                  </p>
                </div>
                <button v-on:click="modalClose()" class="button fs16 w100p mt16 pd16 radius200">閉じる</button>
              </div>
            </div>
          </div>
        </div>
        <!-- /.modal_container -->
      </div>
    </div>
    <button v-on:click="carPage()" id="isInitial" class="button fs16 mb20 pd16 w80p" style="display: none;"></button>

  </div>
  <div v-else-if="isEstimateDetail">
    <a id="isEstimateDetail" v-on:click="toInitial()"></a>
    <EstimateDetailBefore v-bind:car="this.carStore.car" v-bind:price="price" v-bind:expiryOnWareki="expiryOnWareki" v-bind:firstRegistrationOnWareki="firstRegistrationOnWareki" v-bind:Manufacturer="Manufacturer" v-bind:carType="carType"></EstimateDetailBefore>
  </div>
  <div v-else-if="isAgreement">
    <a id="isAgreement" v-on:click="toInitial()"></a>
    <Agreement></Agreement>
  </div>
  <div v-else-if="isLeaseTop">
    <a id="isLeaseTop" v-on:click="toInitial()"></a>
    <LeaseTopComponent
      v-bind:popinfoid="this.nativeDataStore.nativeData.popinfoid"
      v-bind:tsid="this.nativeDataStore.nativeData.tsid"
      v-bind:otoken="this.nativeDataStore.nativeData.otoken"
      v-bind:oilExchanged="this.carStore.car.oil_exchanged"
      v-bind:mileage="this.carStore.car.mileage"
      v-bind:x_cls_app_version="this.versionDataStore.versionData.appVersion"
      v-bind:x_cls_os="this.versionDataStore.versionData.platform"
      v-bind:x_cls_os_version="this.versionDataStore.versionData.osVersion"
    ></LeaseTopComponent>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EstimateDetailBefore from '@/views/v2/EstimateDetailBefore.vue'
import price from '@/store/Api/price'
import carTypeApi from '@/store/Api/cartype'
import manufacturersApi from '@/store/Api/manufacturers'
import Lease from '@/views/v2/Lease.vue'
import Agreement from '@/views/v2/Agreement.vue'
import moment from 'moment'
import Loading from '@/views/v2/Loading.vue'
import modal from '@/assets/v2/modal'
import LeaseTopComponent from '@/components/v2/LeaseTopComponent.vue'
import shopDetailsCallingApi from '@/store/Api/Pitlock/shopDetailsCalling'
import config from '@/v2/config'
import { useSsInfoStore } from '@/store/ssInfo'
import { useProfileInfoStore } from '@/store/profileInfo'
import { useNativeDataStore } from '@/store/nativeData'
import { useVersionDataStore } from '@/store/versionData'
import { useCarStore } from '@/store/carData'
import { useInspectSsInfoStore } from '@/store/inspectSsInfo'
import { useTsIdStore } from '@/store/tsId'
import { usePreferredDateStore } from '@/store/preferredDate'

const IS_INITIAL = 'IS_INITIAL'
const IS_ESTIMATE_DETAIL = 'IS_ESTIMATE_DETAIL'
const IS_AGREEMENT = 'IS_AGREEMENT'
const IS_LEASETOP = 'IS_LEASETOP'

export default {
  methods: {
    ...mapActions('PRICE', [
      'setPrice'
    ]),
    dateParse (date) {
      const year = Number(date.substr(0, 4))
      const month = Number(date.substr(5, 2)) - 1
      const day = Number(date.substr(8, 2))
      return new Date(year, month, day)
    },
    modalOpen (about) {
      window.modalHeight = window.pageYOffset
      // トラッキング処理
      if (about.target.id === 'targetParts') {
        this.nativeEVENTSet('ShakenSyosaiButton', 'MOVED_SHAKEN_TAISHO', 'TAP')
        this.modalTagetParts = true
      } else if (about.target.id === 'reasonMaint') {
        this.nativeEVENTSet('ShakenSeibiRiyuuButton', 'MOVED_SHAKEN_SEIBI_RIYUU', 'TAP')
        this.modalReasonMaintActive = true
      }
      this.modalActive = true
      window.scrollTo(0, 0)
    },
    modalClose () {
      window.scrollTo(0, window.modalHeight)
      this.modalTagetParts = false
      this.modalReasonMaintActive = false
      this.modalActive = false
    },
    toInitial () {
      this.currentState = IS_INITIAL
      window.scrollTo(0, 0)
      $(document).ready(function () {
        $('.faq-item').on('click', function () {
          if ($(this).hasClass('active')) {
            $(this).removeClass('active')
            $(this).children('.faq-a').stop().slideUp(300)
          } else {
            $('.faq-item').removeClass('active')
            $(this).addClass('active')
            $('.faq-a').slideUp(200)
            $(this).children('.faq-a').stop().slideDown(200)
          }
        })
      })
    },
    toEstimateDetail () {
      this.currentState = IS_ESTIMATE_DETAIL
      this.nativeEVENTSet('ShakenKekkaButton', 'MOVED_KEKKA_SHOSAI', 'TAP')
      window.scrollTo(0, 0)
    },
    toAgreement () {
      this.currentState = IS_AGREEMENT
      this.nativeEVENTSet('ShakenKekkaButton', 'MOVED_SHAKEN_KOKANKIJYUN', 'TAP')
      window.scrollTo(0, 0)
    },
    toLeaseTop () {
      this.currentState = IS_LEASETOP
      // this.nativeEVENTSet('ShakenKekkaButton', 'MOVED_SHAKEN_KOKANKIJYUN', 'TAP')
      window.scrollTo(0, 0)
    },
    eventTrackStartPreferred () {
      this.nativeEVENTSet('ShakenKekkaButton', 'MOVED_SHAKEN_YOYAKU', 'TAP')
    },
    openErrorModal (message) {
      modal.alert(message)
    },
    jsOpenBrowser: function () {
      const url = this.estimateBannerUrl + this.nativeDataStore.nativeData.popinfoid
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.openBrowser(url)
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.openBrowser.postMessage(url)
      }
    },
    createEstimeteText () {
      let mailtext = `
『コミっと車検』のお見積り%0d%0a
--------------------------------------------%0d%0a
【お見積り金額】%0d%0a
お見積り金額（税込み）` + this.price.total.toLocaleString() + `円%0d%0a
- - - - - - - - - - - - - - - -%0d%0a
【内訳】%0d%0a
・法定費用：` + this.price.legal_fee.subtotal.toLocaleString() + `円%0d%0a
   - 重量税：` + this.price.legal_fee.weight_tax.toLocaleString() + `円%0d%0a
   - 自賠責保険24ヶ月：` + this.price.legal_fee.cali_fee.toLocaleString() + `円%0d%0a
   - 印紙代：` + this.price.legal_fee.revenue_stamp_fee.toLocaleString() + `円%0d%0a
・車検基本料+定額整備費用：` + this.price.price.subtotal.toLocaleString() + '円%0d%0a'

      if (this.price.price.oil_exchanged_fee !== 0) {
        mailtext += ' ・エンジンオイル不要：' + this.price.price.oil_exchanged_fee + '円%0d%0a'
      }

      if (this.price.coupon_fee !== null) {
        mailtext += ' ・クーポン割引金額：' + this.price.coupon_fee + '円%0d%0a'
      }

      mailtext +=
'・（うち消費税：' + Math.floor(this.taxPrice).toLocaleString() + `円)%0d%0a
*重量税はエコカー減税により減額される場合があります。%0d%0a
- - - - - - - - - - - - - - - -%0d%0a
【お申込み方法】%0d%0a
Carlife Squareアプリで再度お見積りの上、連絡先の入力と最終確認をお願いします。%0d%0a
店舗から日程調整のお電話をさせていただきます。（アプリからの申込みキャンセルは無料です）%0d%0a
・SS名：` + this.inspectSsInfoStore.inspectSsInfo.ss_name + `%0d%0a
・住所：` + this.inspectSsInfoStore.inspectSsInfo.address + `%0d%0a
・電話番号：` + this.inspectSsInfoStore.inspectSsInfo.tel + `%0d%0a
・カーケア営業時間：` + this.inspectSsInfoStore.inspectSsInfo.opening_hours_carcare + `%0d%0a
- - - - - - - - - - - - - - - -%0d%0a
【コミっと車検の特徴】%0d%0a
（1）対象の部品・オイル交換含むコミコミ価格！追加費用なし！%0d%0a
*対象の部品について、異常がある場合は追加費用なしで交換します。%0d%0a
（2）来店不要でお見積り%0d%0a
（3）法定料金もクレジットカードでまとめて決済%0d%0a
（4）半年間の整備保証に加えて、法定12ヶ月点検も無料！%0d%0a
- - - - - - - - - - - - - - - -%0d%0a
【お見積りの車両情報】%0d%0a
・車検満了日：` + this.expiryOnWareki.gengo + this.expiryOnWareki.year + '年' + this.expiryOnWareki.month + '月' + this.expiryOnWareki.date + `日%0d%0a
・初度登録年月：` + this.firstRegistrationOnWareki.gengo + this.firstRegistrationOnWareki.year + '年' + this.firstRegistrationOnWareki.month + `月%0d%0a
・自動車種別：` + this.carType.name + `%0d%0a
・車名（メーカー）：` + this.Manufacturer.manufacturer_name + `%0d%0a
・車体重量：` + this.carStore.car.weight.toLocaleString() + `kg%0d%0a
・走行距離：` + this.mileageWordSet(this.carStore.car.mileage).toLocaleString() + `%0d%0a
--------------------------------------------
`
      return mailtext
    },
    sendMail () {
      location.href = 'mailto:?subject=コミっと車検お見積り金額のお知らせ&body=' + this.createEstimeteText()
    },
    nextPage () {
      this.eventTrackStartPreferred()

      const preferredDateStore = usePreferredDateStore()
      preferredDateStore.preferredDate = {
        price: this.price,
        car: this.carStore.car,
        expiryOnWareki: this.expiryOnWareki,
        firstRegistrationOnWareki: this.firstRegistrationOnWareki,
        Manufacturer: this.Manufacturer,
        carType: this.carType,
        nativeData: this.nativeDataStore.nativeData,
        tsId: this.tsIdStore.tsId,
        ssInfo: this.ssInfoStore.ssInfo,
        // 車検実施SS
        inspectSsInfo: this.inspectSsInfoStore.inspectSsInfo,
        profileInfo: this.profileInfoStore.profileInfo,
        versionData: this.versionDataStore.versionData,
        pitlockshopDetails: this.pitlockshopDetails
      }

      this.$router.push({ name: 'PreferredDateV2' })
    },
    carPage () {
      const nativeDataStore = useNativeDataStore()
      nativeDataStore.nativeData = this.nativeDataStore.nativeData
      const tsIdStore = useTsIdStore()
      tsIdStore.tsId = this.tsIdStore.tsId
      const ssInfoStore = useSsInfoStore()
      ssInfoStore.ssInfo = this.ssInfoStore.ssInfo
      const inspectSsInfoStore = useInspectSsInfoStore()
      inspectSsInfoStore.inspectSsInfo = this.inspectSsInfoStore.inspectSsInfo
      const profileInfoStore = useProfileInfoStore()
      profileInfoStore.profileInfo = this.profileInfoStore.profileInfo
      const versionDataStore = useVersionDataStore()
      versionDataStore.versionData = this.versionDataStore.versionData

      this.$router.push({ name: 'CarV2' })
    }
  },
  computed: {
    ...mapGetters('PRICE', [
      'price'
    ]),
    isInitial () {
      return this.currentState === IS_INITIAL
    },
    isEstimateDetail () {
      return this.currentState === IS_ESTIMATE_DETAIL
    },
    isAgreement () {
      return this.currentState === IS_AGREEMENT
    },
    isLeaseTop () {
      return this.currentState === IS_LEASETOP
    },
    taxPrice: function () {
      // 車検基本料、定額整備費用＋エンジンオイル不要割＋クーポン料金
      let price = (this.price.price.base_price + this.price.price.oil_exchanged_fee + this.price.coupon_fee)
      // 消費税率を掛ける
      price = Math.round(price * this.taxRate() * 10)
      price = price / 10
      // 1 + 消費税率を割る
      price = Math.round(price / (1 + this.taxRate()) * 10)
      price = price / 10
      return price
    },
    carStore: function () {
      return useCarStore()
    },
    ssInfoStore: function () {
      return useSsInfoStore()
    },
    profileInfoStore: function () {
      return useProfileInfoStore()
    },
    nativeDataStore: function () {
      return useNativeDataStore()
    },
    versionDataStore: function () {
      return useVersionDataStore()
    },
    inspectSsInfoStore: function () {
      return useInspectSsInfoStore()
    },
    tsIdStore: function () {
      return useTsIdStore()
    }
  },
  async mounted () {
    console.log(location.href)
    $(document).ready(function () {
      $('.faq-item').on('click', function () {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active')
          $(this).children('.faq-a').stop().slideUp(300)
        } else {
          $('.faq-item').removeClass('active')
          $(this).addClass('active')
          $('.faq-a').slideUp(200)
          $(this).children('.faq-a').stop().slideDown(200)
        }
      })
    })
    // 戻るボタンの出し分け
    this.appDisplayBack(true)

    let isApiError = false

    this.estimateBannerUrl = process.env.VUE_APP_CAMPAIGN_URL

    // 見積り金額計算API
    await price.post({ ...this.carStore.car, otoken: this.nativeDataStore.nativeData.otoken }, this.appVersionMakeRequestHeder(this.versionDataStore.versionData)).then(res => {
      this.setPrice(res.data)
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // 車検満了日、初度登録年月の和暦を取得する。
    this.expiryOnWareki = this.toWareki(this.carStore.car.expiry_on)
    this.firstRegistrationOnWareki = this.toWareki(this.carStore.car.first_registration_on + '-01')
    // APIから自動車の種別、車名（メーカー）を取得する。
    await carTypeApi.getDetail(this.carStore.car.model_code).then(res => {
      this.carType = res.data.car_type
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    await manufacturersApi.getDetail(this.carStore.car.manufacturer_id).then(res => {
      this.Manufacturer = res.data.manufacturer
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // PITLOCKのstore_idは空文字も存在するため、store_idがあった場合のみ、
    // CLSストアID店舗詳細情報取得APIを呼び出す
    if (this.inspectSsInfoStore.inspectSsInfo.store_id) {
      await shopDetailsCallingApi.get(this.inspectSsInfoStore.inspectSsInfo.store_id).then(res => {
        this.pitlockshopDetails = res.data.body

        // コミっと車検導入フラグが対応不可の場合もメンテ同様、次へボタンを非活性とする
        if (this.pitlockshopDetails.commit_vehicle_inspection_flag === 0) {
          this.pitlockIsMaintenance = true
        }
      }).catch(e => {
        e.response.data.body.error_info.forEach(element => {
          // PITLOCKがメンテナンス時の場合のみ、次へボタンを非活性とする
          if (element.error_code === config.PITLOCK_ERROR_CODE_MAINTENANCE) {
            this.pitlockIsMaintenance = true
          }
        })

        // PITLOCKメンテ以外の場合のエラーダイアログを表示
        if (!this.pitlockIsMaintenance) {
          if (!isApiError) {
            this.openErrorModal('エラーが発生しました。')
            isApiError = true
          }
        }
      })
    }

    // 現在時刻から半年後の時間変数を作成
    this.sixMonthLater = moment().add(6, 'months').toDate()
    // 比較用に車検満了日をDate型に変換
    this.expiryOnDate = this.dateParse(this.carStore.car.expiry_on)
    // [eventTrack] 車検見積り 画面表示完了
    this.nativePVset('SHAKEN_MITSUMORI_KEKKA')
    if (!isApiError) {
      this.loading = false
    }
  },
  data () {
    return {
      loading: true,
      expiryOnWareki: {},
      firstRegistrationOnWareki: {},
      carType: {},
      Manufacturer: {},
      sixMonthLater: '',
      expiryOnDate: '',
      currentState: IS_INITIAL,
      estimateBannerUrl: '',
      modalActive: false,
      modalTagetParts: false,
      modalReasonMaintActive: false,
      currentDate: moment().format('M月D日'),
      pitlockshopDetails: {},
      pitlockIsMaintenance: false
    }
  },
  components: {
    EstimateDetailBefore,
    Agreement,
    Lease,
    Loading,
    LeaseTopComponent
  }
}

</script>

<style></style>
